import type { RouterOptions } from '@nuxt/schema';

export default <RouterOptions>{
  scrollBehaviorType: 'smooth',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;

    // Query-only навигация (тогглы фильтров вроде ?two-plus-one=1) не скроллит страницу.
    if (to.path === from.path) return false;

    const isCatalogNav = to.path === '/' || to.path.startsWith('/catalog');

    if (isCatalogNav) return false;

    return { top: 0 };
  },
};
